import { render, staticRenderFns } from "./PublishingProjectsReadOnly.vue?vue&type=template&id=45690cec"
import script from "./PublishingProjectsReadOnly.vue?vue&type=script&lang=js"
export * from "./PublishingProjectsReadOnly.vue?vue&type=script&lang=js"
import style0 from "./PublishingProjectsReadOnly.vue?vue&type=style&index=0&id=45690cec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports